//@ts-nocheck
import { Divider, Dropdown, Form, Grid, Input, Text } from '@wework/dieter-ui'
import React, { useEffect, useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'
import SATextHolder from './SATextHolder'

const noViewOptions = [
  {
    key: 'No Window - View',
    text: 'No Window - View',
    value: 'NO_WINDOW_VIEW',
  },
  {
    key: 'No Window - No View',
    text: 'No Window - No View',
    value: 'NO_WINDOW_NO_VIEW',
  },
  {
    key: 'Unknown',
    text: 'Unknown',
    value: 'UNKNOWN_VIEW',
  },
]

const ViewOptions = [
  {
    key: 'Window - Above average',
    text: 'Window - Above average',
    value: 'WINDOW_ABOVE_AVERAGE_VIEW',
  },
  {
    key: 'Window - Average',
    text: 'Window - Average',
    value: 'WINDOW_AVERAGE_VIEW',
  },
  {
    key: 'Window - Below average',
    text: 'Window - Below average',
    value: 'WINDOW_BELOW_AVERAGE_VIEW',
  },
  {
    key: 'Unknown',
    text: 'Unknown',
    value: 'UNKNOWN_VIEW',
  },
]

export default function EditPhysicalSpaceOffice({
  space,
  roomData,
  setRoomData,
}) {
  const [viewQuality, setViewQuality] = useState<any>('Unknown')
  const [lightQuality, setLightQuality] = useState<any>('Unknown')
  const [obstructions, setObstructions] = useState<any>(
    roomData?.obstructions > 0
  )
  const { openSideBar } = useSidebar()
  useEffect(() => {
    if (roomData) {
      setObstructions(roomData?.obstructions > 0)
    }
  }, [roomData, roomData?.obstructions])

  useEffect(() => {
    if (!obstructions) {
      setRoomData({ ...roomData, obstructions: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obstructions])
  if (!space) {
    return null
  }
  return (
    <>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Attributes</Text>
            <Text
              size="tiny"
              style={{ backgroundColor: '#F7F7F7', padding: '16px' }}
            >
              ⭐ Updated spaces can help improve our inventory quality, keep
              teams informed and improve our overall sales process!
            </Text>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {/* </div> */}
      <Text style={{ margin: '24px 0px', fontSize: 14, fontWeight: 'bold' }}>
        Windows & light
      </Text>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="Does the space have externally facing windows?"
              text="If unsure, leave settings to no"
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="External windows"
              control={Dropdown}
              outline
              selection={true}
              onChange={(e, data) => {
                setRoomData({ ...roomData, has_window: data.value === 'true' })
                setViewQuality('Unknown')
              }}
              value={roomData?.has_window?.toString()}
              options={[
                {
                  key: 'Yes',
                  text: 'Yes',
                  value: 'true',
                },
                {
                  key: 'No',
                  text: 'No',
                  value: 'false',
                },
              ]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="What is the view quality?"
              text="Scenic views, average, obstructed views."
              example
              type="VIEW"
              value={roomData.view_quality}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="External view quality"
              control={Dropdown}
              outline
              //@ts-ignore
              onChange={(e, data) => {
                setRoomData({ ...roomData, view_quality: data.value })
              }}
              value={roomData.view_quality}
              defaultValue={roomData.view_quality}
              options={
                roomData.has_window === true ? ViewOptions : noViewOptions
              }
              selection={true}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="What is the natural light quality?"
              text="Exceptional, average, interior with no natural light."
              example
              type="LIGHT"
              value={roomData.light_quality}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="Natural light quality"
              control={Dropdown}
              outline
              //@ts-ignore
              onChange={(e, data) => {
                setRoomData({ ...roomData, light_quality: data.value })
              }}
              value={roomData.light_quality}
              selection={true}
              defaultValue={'UNKNOWN_LIGHT'}
              options={[
                {
                  key: 'Above Average',
                  text: 'Above Average',
                  value: 'ABOVE_AVERAGE_LIGHT',
                },
                {
                  key: 'Average',
                  text: 'Average',
                  value: 'AVERAGE_LIGHT',
                },
                {
                  key: 'Below Average',
                  text: 'Below Average',
                  value: 'BELOW_AVERAGE_LIGHT',
                },
                {
                  key: 'Unknown',
                  text: 'Unknown',
                  value: 'UNKNOWN_LIGHT',
                },
              ]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Text style={{ margin: '24px 0px', fontSize: 14, fontWeight: 'bold' }}>
        Interior details
      </Text>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="Are there any obstructions?"
              text="An Obstruction is any sizeable object that limits the usage of space (e.g. columns)."
              example
              type="OBSTRUCTIONS"
              value={obstructions}
            />
          </Grid.Column>

          <Grid.Column width={8}>
            <Form.Group widths="equal">
              <Form.Field
                label="Obstructions"
                control={Dropdown}
                defaultValue={roomData?.obstructions === 0 ? true : false}
                outline
                fluid
                size="small"
                onChange={(e, data) => {
                  setObstructions(data.value)
                }}
                value={obstructions}
                selection={true}
                options={[
                  {
                    key: 'Yes',
                    text: 'Yes',
                    value: true,
                  },
                  {
                    key: 'No',
                    text: 'No',
                    value: false,
                  },
                ]}
              />
              <Form.Field
                label="How many"
                min={0}
                control={Input}
                disabled={!obstructions}
                value={roomData?.obstructions?.toString()}
                size="small"
                type="number"
                onChange={(e, data) => {
                  if (data.value > 0) {
                    setRoomData({
                      ...roomData,
                      obstructions: parseInt(data.value.toString()),
                    })
                  }
                }}
                fluid
                outline
                placeholder="NA"
                style={{ fontSize: 14 }}
              />
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="Does the space have a solid wall?"
              text="An interior wall in the space that is not glass"
            />
          </Grid.Column>

          <Grid.Column width={8}>
            <Form.Field
              label="Solid Wall"
              control={Dropdown}
              outline
              fluid
              selection={true}
              onChange={(e, data) => {
                setRoomData({
                  ...roomData,
                  has_solid_wall: data.value === 'true',
                })
              }}
              value={roomData.has_solid_wall?.toString()}
              defaultValue={'false'}
              options={[
                {
                  key: 'Yes',
                  text: 'Yes',
                  value: 'true',
                },
                {
                  key: 'No',
                  text: 'No',
                  value: 'false',
                },
              ]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%', marginBottom: 16 }} />
      <Grid.Row stretched>
        <Grid.Column width={8} style={{ width: '50%' }}>
          <>
            <SATextHolder
              title="Internal rooms"
              text="Rooms that you can access only by entering this space."
            />
          </>
        </Grid.Column>
        <Grid.Column
          width={8}
          style={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Text
            style={{ fontSize: 14, cursor: 'pointer' }}
            primary
            disabled={!roomData.id}
            onClick={() => roomData.id && openSideBar('InternalRooms')}
          >
            {roomData?.metrics?.internalRooms > 0
              ? `${roomData?.metrics?.internalRooms} Internal rooms`
              : 'No internal rooms'}
            {' >'}
          </Text>
        </Grid.Column>
      </Grid.Row>
    </>
  )
}
